import React, { Component } from 'react';
import { InfoIcon } from './Icons';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import UserDataConsumer from '../../utils/UserDataConsumer';
import { connect } from 'react-redux';
import { UserNotificationBadge } from './NotificationBadge';
import { UserProfile } from '../../../../gym-core/lib/entities/user/userprofile';
import { BaseUserProfile } from 'fitbeat.models';
import { InitialsCircle } from './InitialsCircle';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
import { profileColors } from 'fitbeat.models';

interface IProps {
  navigation: any;
  shouldShowFamilyPlanIcon?: boolean;
  userProfile: UserProfile;
}

class InfoAndNotificationBadge extends Component<IProps> {
  constructor(props) {
    super(props);
  }

  public render() {
    const { userProfile, navigation, shouldShowFamilyPlanIcon } = this.props;

    if (shouldShowFamilyPlanIcon && BaseUserProfile.isPartOfFamilyPlan(userProfile)) {
      return (
        <View style={styles.container}>
          <View style={{paddingTop: defaultScale(3)}}>
            <UserNotificationBadge navigation={navigation} />
          </View>
          <TouchableOpacity style={styles.initialsContainer} onPress={() => navigation.navigate('SwitchMemberSummaryDashboard')}>
            <InitialsCircle
              initials={BaseUserProfile.getUserInitials(userProfile)}
              backgroundColor={BaseUserProfile.getProfileColor(userProfile) ?? profileColors[0]}
              color={Theme.WHITE}
              size={defaultScale(30)}
              textStyle={styles.userIconText}
            />
          </TouchableOpacity>
        </View>
      );
    }

    return (
      <View style={styles.container}>
        <InfoIcon navigation={this.props.navigation} />
        <UserNotificationBadge navigation={this.props.navigation} />
      </View>
    )
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
    },
    initialsContainer: {
      marginRight: defaultScale(10),
    },
    userIconText: {
      color: Theme.WHITE,
      fontFamily: Theme.Weight700,
      fontSize: defaultScale(14),
    },
});

const mapStateToProps = (state, ownProps): Partial<IProps> => {
  return {
    userProfile: ownProps.user.userProfile,
  };
};

export default UserDataConsumer(connect(mapStateToProps)(InfoAndNotificationBadge));
